var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25977 5.21429C6.25977 5.13393 6.21959 5.04353 6.15932 4.98326L1.47852 0.302455C1.41825 0.242188 1.32785 0.202008 1.24749 0.202008C1.16713 0.202008 1.07673 0.242188 1.01646 0.302455L0.51423 0.804688C0.453962 0.864955 0.413783 0.955357 0.413783 1.03571C0.413783 1.11607 0.453962 1.20647 0.51423 1.26674L4.46177 5.21429L0.51423 9.16183C0.453962 9.2221 0.413783 9.3125 0.413783 9.39286C0.413783 9.48326 0.453962 9.56362 0.51423 9.62388L1.01646 10.1261C1.07673 10.1864 1.16713 10.2266 1.24749 10.2266C1.32785 10.2266 1.41825 10.1864 1.47852 10.1261L6.15932 5.44531C6.21959 5.38504 6.25977 5.29464 6.25977 5.21429Z",
    fill: "#19352A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.a09bfb8a06a82ed7f2fcc9ea0a717efe.svg";
export { ForwardRef as ReactComponent };